module.exports = __webpack_public_path__ + "static/media/coverImage.2af2fa1b.jpg";